export default "__VITE_ASSET__DrhhilEb__"